export default "__VITE_ASSET__OwJpeOtg__";